import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class FurnaceBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.FURNACE;
}

export default FurnaceBuildingTileEntity;
